// ThinkyBaaSHome.jsx
import React, { useState } from "react";
import {
  faServer,
  faUserShield,
  faFileContract,
  faDatabase,
  faPlug,
  faGavel,
  faChartBar,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ThinkyBaaSOverview from "./ThinkyBaaSOverview ";
import ThinkyBaaSNetwork from "./ThinkyBaaSNetwork";
import ThinkyBaaSIdentity from "./ThinkyBaaSIdentity";
import ThinkyBaaSSmartContracts from "./ThinkyBaaSSmartContracts";
import ThinkyBaaSLedger from "./ThinkyBaaSLedger";
import ThinkyBaaSIntegration from "./ThinkyBaaSIntegration";
import ThinkyBaaSGovernance from "./ThinkyBaaSGovernance";
import ThinkyBaaSAnalytics from "./ThinkyBaaSAnalytics";
import ThinkyBaaSSecurity from "./ThinkyBaaSSecurity";
import ThinkyBaaSCompetitors from "./ThinkyBaaSCompetitors";

const tabs = [
  { name: "Overview", icon: faServer, component: <ThinkyBaaSOverview  /> },  
  { name: "Smart Contracts", icon: faFileContract, component: <ThinkyBaaSSmartContracts /> },
  { name: "Ledger & Data", icon: faDatabase, component: <ThinkyBaaSLedger /> },
  { name: "Identity & Access", icon: faUserShield, component: <ThinkyBaaSIdentity /> },
  { name: "Analytics & Reporting", icon: faChartBar, component: <ThinkyBaaSAnalytics /> },
  { name: "Governance & Compliance", icon: faGavel, component: <ThinkyBaaSGovernance /> },
  { name: "Security & Privacy", icon: faLock, component: <ThinkyBaaSSecurity /> },
  { name: "Integration & APIs", icon: faPlug, component: <ThinkyBaaSIntegration /> },
  { name: "Network & Infra", icon: faServer, component: <ThinkyBaaSNetwork /> },
  { name: "Other Service Providers", icon: faServer, component: <ThinkyBaaSCompetitors /> },
];

const ThinkyBaaSHome = () => {
  const [activeTab, setActiveTab] = useState("Smart Contracts");

  return (
    <div className="min-h-screen bg-black text-white p-4 md:p-8">
      <h1 className="text-xl lg:text-2xl font-bold mb-6 text-center">
        ⛓️ Thinky Blockchain
      </h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-1 mb-2 place-items-center py-4 border-b border-t border-blue-400">
        {tabs.map((tab) => (
            <button
            key={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`w-40 lg:w-44 h-10
                flex items-start justify-start
                text-xs lg:text-sm
                px-3 py-2 rounded-md
                border border-gray-700
                transition-all duration-200
                ${
                activeTab === tab.name
                    ? "bg-blue-500 border-blue-500"
                    : "hover:bg-gray-800"
                }`}
            >
            <FontAwesomeIcon icon={tab.icon} className="mr-2" />
            <span className="truncate">{tab.name}</span>
            </button>
        ))}
        </div>

      <div className="mt-4">{tabs.find((t) => t.name === activeTab)?.component}</div>
    </div>
  );
};

export default ThinkyBaaSHome;
